import { join, pipe, replace, toLower } from 'ramda'

const BUILDING_TYPE = {
  condo: 'apartment',
  highrise: 'apartment',
  lowrise: 'apartment',
  house: 'house',
  townhouse: 'townhouse'
}

export const getListingUrl = (
  listing: any,
  isFeatured: boolean = false
): string => {
  if (!listing) return ''

  if (isFeatured) {
    const targetListing = Array.isArray(listing) ? listing[0] : listing

    return join('/', [
      '/rental-listings/detail',
      BUILDING_TYPE[
        targetListing.building_type as keyof typeof BUILDING_TYPE
      ] || 'apartment',
      pipe(
        toLower,
        replace(/ /g, '-'),
        replace(/_/g, '-')
      )(targetListing.city || ''),
      targetListing.listing_id || targetListing.ids?.listing_id || ''
    ])
  } else {
    const listingId =
      listing.listing_id ||
      (listing.listings && listing.listings[0]?.listing_id) ||
      ''

    const buildingType =
      listing.building_type ||
      (listing.listings && listing.listings[0]?.building_type) ||
      'apartment'

    return join('/', [
      '/rental-listings/detail',
      BUILDING_TYPE[buildingType as keyof typeof BUILDING_TYPE] || 'apartment',
      pipe(toLower, replace(/ /g, '-'), replace(/_/g, '-'))(listing.city || ''),
      listingId
    ])
  }
}
